/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Communicationdefect1Inputs */



/**
* | output |
* | --- |
* | "Communication fault" |
*
* @param {Ahu_History_Key_Communicationdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_communicationdefect1 = /** @type {((inputs?: Ahu_History_Key_Communicationdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Communicationdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Communication fault")
	return /** @type {LocalizedString} */ ("Défaut communication")
});
export { ahu_history_key_communicationdefect1 as "ahu_history_key_communicationDefect" }